var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _rect, _path19, _g2, _rect2, _path20, _g3, _rect3, _path21, _g4, _rect4, _path22, _rect5, _rect6, _rect7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerboseLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 329,
    viewBox: "0 0 575 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.344 320.957V309.033H301.445V320.957H292.344Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.76 324.516V324.515C282.76 322.55 284.96 320.956 287.674 320.956H306.533C309.247 320.956 311.446 322.55 311.446 324.515V324.516C311.446 326.482 309.247 328.076 306.533 328.076H287.674C284.96 328.076 282.76 326.482 282.76 324.516Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.714 305.677C294.095 305.677 291.984 303.558 291.984 300.946C291.984 298.336 294.095 296.216 296.714 296.216C299.326 296.216 301.445 298.336 301.445 300.946C301.445 303.558 299.326 305.677 296.714 305.677ZM308.813 247.796H322.127C322.679 247.796 323.127 247.348 323.127 246.796V245.469C323.127 238.178 320.17 231.57 315.388 226.795C310.614 222.013 304.013 219.057 296.714 219.057C282.125 219.057 270.294 230.88 270.294 245.469V246.796C270.294 247.348 270.742 247.796 271.294 247.796H284.607C285.417 247.796 286.141 248.123 286.675 248.649C287.201 249.183 287.528 249.916 287.528 250.716C287.528 252.336 286.218 253.638 284.607 253.638H271.294C270.742 253.638 270.294 254.086 270.294 254.638V258.343C270.294 258.895 270.742 259.343 271.294 259.343H284.607C285.417 259.343 286.141 259.67 286.675 260.196C287.201 260.73 287.528 261.462 287.528 262.264C287.528 263.884 286.218 265.194 284.607 265.194H271.294C270.742 265.194 270.294 265.641 270.294 266.194V269.889C270.294 270.442 270.742 270.889 271.294 270.889H284.607C285.417 270.889 286.141 271.218 286.675 271.751C287.201 272.277 287.528 273.01 287.528 273.819C287.528 275.431 286.218 276.741 284.607 276.741H271.294C270.742 276.741 270.294 277.189 270.294 277.741V281.446C270.294 281.998 270.742 282.446 271.294 282.446H284.607C285.417 282.446 286.141 282.773 286.675 283.299C287.201 283.825 287.528 284.556 287.528 285.367C287.528 286.978 286.218 288.288 284.607 288.288H270.38C270.333 288.288 270.294 288.327 270.294 288.374V288.374C270.294 302.963 282.125 314.786 296.714 314.786C311.304 314.786 323.127 302.963 323.127 288.374V288.374C323.127 288.327 323.088 288.288 323.041 288.288H308.813C308.012 288.288 307.28 287.96 306.745 287.435C306.219 286.9 305.892 286.177 305.892 285.367C305.892 283.747 307.202 282.446 308.813 282.446H322.127C322.679 282.446 323.127 281.998 323.127 281.446V277.741C323.127 277.189 322.679 276.741 322.127 276.741H308.813C308.012 276.741 307.28 276.413 306.745 275.888C306.219 275.354 305.892 274.63 305.892 273.819C305.892 272.2 307.202 270.889 308.813 270.889H322.127C322.679 270.889 323.127 270.442 323.127 269.889V266.194C323.127 265.641 322.679 265.194 322.127 265.194H308.813C308.012 265.194 307.28 264.866 306.745 264.341C306.219 263.807 305.892 263.074 305.892 262.264C305.892 260.653 307.202 259.343 308.813 259.343H322.127C322.679 259.343 323.127 258.895 323.127 258.343V254.638C323.127 254.086 322.679 253.638 322.127 253.638H308.813C308.012 253.638 307.28 253.311 306.745 252.785C306.219 252.259 305.892 251.527 305.892 250.716C305.892 249.106 307.202 247.796 308.813 247.796Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.005 289.011C252.178 289.011 250.698 287.53 250.698 285.704V248.14C250.698 246.312 252.178 244.832 254.005 244.832C255.832 244.832 257.313 246.312 257.313 248.14V285.704C257.313 287.53 255.832 289.011 254.005 289.011Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.773 282.456C238.945 282.456 237.464 280.975 237.464 279.148V254.694C237.464 252.867 238.945 251.386 240.773 251.386C242.6 251.386 244.081 252.867 244.081 254.694V279.148C244.081 280.975 242.6 282.456 240.773 282.456Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.54 277.358C225.713 277.358 224.233 275.877 224.233 274.05V259.793C224.233 257.965 225.713 256.484 227.54 256.484C229.367 256.484 230.848 257.965 230.848 259.793V274.05C230.848 275.877 229.367 277.358 227.54 277.358Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M237.463 265.676V274.789C237.463 273.872 237.097 273.046 236.497 272.446C235.897 271.853 235.064 271.478 234.154 271.478C232.324 271.478 230.849 272.962 230.849 274.789V265.676C230.849 267.504 232.324 268.986 234.154 268.986C235.981 268.986 237.463 267.504 237.463 265.676Z",
    fill: "url(#paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250.7 256.245V265.676C250.7 264.765 250.331 263.939 249.732 263.34C249.138 262.74 248.305 262.372 247.395 262.372C245.567 262.372 244.085 263.855 244.085 265.676V256.245C244.085 258.073 245.567 259.555 247.395 259.555C249.224 259.555 250.7 258.073 250.7 256.245Z",
    fill: "url(#paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250.7 270.074V279.506C250.7 278.595 250.331 277.769 249.732 277.169C249.138 276.569 248.305 276.202 247.395 276.202C245.567 276.202 244.085 277.684 244.085 279.506V270.074C244.085 271.902 245.567 273.385 247.395 273.385C249.224 273.385 250.7 271.902 250.7 270.074",
    fill: "url(#paint5_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.308 272.015C212.48 272.015 211 270.533 211 268.707V265.136C211 263.308 212.48 261.827 214.308 261.827C216.135 261.827 217.616 263.308 217.616 265.136V268.707C217.616 270.533 216.135 272.015 214.308 272.015Z",
    fill: "url(#paint6_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339.784 289.011C341.611 289.011 343.091 287.53 343.091 285.704V248.14C343.091 246.312 341.611 244.832 339.784 244.832C337.957 244.832 336.475 246.312 336.475 248.14V285.704C336.475 287.53 337.957 289.011 339.784 289.011Z",
    fill: "url(#paint7_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M353.016 282.456C354.843 282.456 356.325 280.975 356.325 279.148V254.694C356.325 252.867 354.843 251.386 353.016 251.386C351.189 251.386 349.708 252.867 349.708 254.694V279.148C349.708 280.975 351.189 282.456 353.016 282.456Z",
    fill: "url(#paint8_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366.248 277.358C368.076 277.358 369.556 275.877 369.556 274.05V259.793C369.556 257.965 368.076 256.484 366.248 256.484C364.422 256.484 362.94 257.965 362.94 259.793V274.05C362.94 275.877 364.422 277.358 366.248 277.358Z",
    fill: "url(#paint9_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M356.325 265.676V274.789C356.325 273.872 356.692 273.046 357.292 272.446C357.892 271.853 358.725 271.478 359.635 271.478C361.465 271.478 362.939 272.962 362.939 274.789V265.676C362.939 267.504 361.465 268.986 359.635 268.986C357.808 268.986 356.325 267.504 356.325 265.676",
    fill: "url(#paint10_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.089 256.245V265.676C343.089 264.765 343.457 263.939 344.057 263.34C344.65 262.74 345.483 262.372 346.394 262.372C348.222 262.372 349.704 263.855 349.704 265.676V256.245C349.704 258.073 348.222 259.555 346.394 259.555C344.565 259.555 343.089 258.073 343.089 256.245",
    fill: "url(#paint11_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M343.089 270.074V279.506C343.089 278.595 343.457 277.769 344.057 277.169C344.65 276.569 345.483 276.202 346.394 276.202C348.222 276.202 349.704 277.684 349.704 279.506V270.074C349.704 271.902 348.222 273.385 346.394 273.385C344.565 273.385 343.089 271.902 343.089 270.074",
    fill: "url(#paint12_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M379.481 272.015C381.309 272.015 382.789 270.533 382.789 268.707V265.136C382.789 263.308 381.309 261.827 379.481 261.827C377.654 261.827 376.173 263.308 376.173 265.136V268.707C376.173 270.533 377.654 272.015 379.481 272.015Z",
    fill: "url(#paint13_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M356.322 253.427C356.322 254.995 356.258 256.541 356.144 258.081H349.498C349.632 256.549 349.703 254.995 349.703 253.427C349.703 232.166 337.14 213.842 319.036 205.471L318.92 205.785C318.245 207.636 316.186 208.579 314.345 207.873C308.929 205.795 303.044 204.655 296.895 204.655C290.746 204.655 284.86 205.795 279.444 207.873C277.603 208.579 275.544 207.636 274.869 205.785L274.754 205.471C256.649 213.842 244.087 232.166 244.087 253.427C244.087 254.995 244.157 256.549 244.292 258.081H237.645C237.532 256.541 237.467 254.995 237.467 253.427C237.467 220.603 264.07 194 296.895 194C329.719 194 356.322 220.603 356.322 253.427",
    fill: "url(#paint14_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.205,
    y: 102.471,
    width: 117.922,
    height: 34.2465,
    rx: 10,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.271 136.717H129.652L118.451 146.304C116.225 148.209 112.868 146.12 113.594 143.281L115.271 136.717Z",
    fill: "#333333"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 76,
    width: 158,
    height: 69.1244,
    rx: 10,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4878 144.203H111.756L94.4211 166.552C92.5086 169.017 88.5709 167.288 89.0929 164.211L92.4878 144.203Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 199.471,
    width: 117.922,
    height: 34.2465,
    rx: 10,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.067 233.717H411.447L400.246 243.304C398.02 245.209 394.663 243.12 395.389 240.281L397.067 233.717Z",
    fill: "#333333"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 392.395,
    y: 173,
    width: 126.4,
    height: 55.2995,
    rx: 10,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M439.295 228H456.295L445.148 245.86C443.568 248.393 439.66 247.314 439.604 244.329L439.295 228Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.2781,
    height: 23.2876,
    rx: 10,
    transform: "matrix(-1 0 0 1 417.278 70)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.681 93.2876H401.257L406.108 97.5955C408.31 99.5509 411.717 97.4942 411.013 94.6348L410.681 93.2876Z",
    fill: "#333333"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 47,
    rx: 10,
    transform: "matrix(-1 0 0 1 440 52)",
    fill: "#262626"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M428.305 98.3779H411.598L425.74 112.677C427.85 114.81 431.439 112.866 430.805 109.933L428.305 98.3779Z",
    fill: "#262626"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.2781,
    height: 23.2876,
    rx: 10,
    transform: "matrix(-1 0 0 1 147.278 228)",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.681 251.288H131.257L136.108 255.596C138.31 257.551 141.717 255.494 141.013 252.635L140.681 251.288Z",
    fill: "#333333"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 76.4706,
    height: 35.9412,
    rx: 10,
    transform: "matrix(-1 0 0 1 170 210)",
    fill: "#262626"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.719 245H132L142.146 256.499C143.494 258.026 145.996 256.797 145.61 254.797L143.719 245Z",
    fill: "#262626"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 96,
    width: 117,
    height: 13,
    rx: 6.5,
    fill: "#262626",
    fillOpacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 67,
    width: 67,
    height: 13,
    rx: 6.5,
    fill: "white",
    fillOpacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 114,
    width: 58,
    height: 13,
    rx: 6.5,
    fill: "#262626",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 35.2048,
    y: 32.4707,
    width: 257.922,
    height: 184.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 317,
    y: 129.471,
    width: 257.922,
    height: 184.567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 270,
    y: 0,
    width: 217.278,
    height: 168.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 0,
    y: 158,
    width: 217.278,
    height: 168.365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 259.673,
    y1: 266.921,
    x2: 211.199,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 259.673,
    y1: 266.921,
    x2: 211.199,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 259.673,
    y1: 266.921,
    x2: 211.199,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 259.673,
    y1: 270.233,
    x2: 211.199,
    y2: 270.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 259.673,
    y1: 260.961,
    x2: 211.199,
    y2: 260.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 259.673,
    y1: 274.79,
    x2: 211.199,
    y2: 274.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 259.673,
    y1: 266.921,
    x2: 211.199,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 334.116,
    y1: 266.921,
    x2: 382.59,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 334.116,
    y1: 266.921,
    x2: 382.59,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 334.115,
    y1: 266.921,
    x2: 382.59,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 334.116,
    y1: 270.233,
    x2: 382.59,
    y2: 270.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 334.116,
    y1: 260.961,
    x2: 382.59,
    y2: 260.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 334.116,
    y1: 274.79,
    x2: 382.59,
    y2: 274.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 334.116,
    y1: 266.921,
    x2: 382.59,
    y2: 266.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 296.895,
    y1: 292.54,
    x2: 296.895,
    y2: 195.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7DA4E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerboseLog);
export default __webpack_public_path__ + "static/media/VerboseLog.2859e376b6a4744fa521969072228faa.svg";
export { ForwardRef as ReactComponent };